'use client';

import dynamic from 'next/dynamic';

/**
 * Fires a fireworks-like confetti using the library 'canvas-confetti'.
 * The confetti only starts after after the cookie banner has been closed (either accepted or declined)
 * and only once every week for the current browser.
 */
export const DynamicConfetti = dynamic(
  () => import(/* webpackChunkName: 'Confetti' */ './Confetti.client').then((mod) => mod.Confetti),
  {
    ssr: false,
  },
);
